import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateBillingCardMutationCgResponse,
  CreateBillingCardMutationVariables,
} from '@common/graphql';

export const CreateBillingCardMutation: TypedDocumentNode<
  CreateBillingCardMutationCgResponse,
  CreateBillingCardMutationVariables
> = gql`
  mutation CreateBillingCard(
    $localRate: BillingCardWorkerRateInput!
    $directSourcingRate: BillingCardWorkerRateInput!
    $travelerRate: BillingCardWorkerRateInput!
    $billingCard: CreateBillingCardInput!
    $organizationUnits: [ID!]!
    $deviatedEntities: DeviatedEntitiesInput
  ) {
    createBillingCard(
      billingCard: $billingCard
      organizationUnits: $organizationUnits
      deviatedEntities: $deviatedEntities
      localRate: $localRate
      directSourcingRate: $directSourcingRate
      travelerRate: $travelerRate
    ) {
      billingCard {
        id
        name
      }
    }
  }
`;
